import { Component, ElementRef, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-pos-view',
  templateUrl: './pos-view.component.html',
  styleUrls: ['./pos-view.component.scss']
})
export class PosViewComponent {

  @Input() display: boolean=false;
  @Input() posView;
  @Output() close = new EventEmitter;
  serialDetails = {}
  constructor(private elementRef: ElementRef) {}

  ngOnChanges(changes: SimpleChanges) {
    if(this.posView){
    const dialogElement = this.elementRef.nativeElement.querySelector('button');
    this.display = !dialogElement;
    }
  }
  


  onClose(){
    this.display = false;
    this.close.emit(false)
  }
}
